// LearningOutcomes.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
//import 'bootstrap-icons/font/bootstrap-icons.css';

const OutcomeItem = ({ iconClass, title, description }) => (
  <Col md={4} className="mb-5">
    <div className="d-flex justify-content-center mb-3">
      <i className={`${iconClass} fs-1 text-primary`} />
    </div>
    <h5 className="text-center">{title}</h5>
    <p className="text-center text-muted">{description}</p>
  </Col>
);

// const LearningOutcomes = () => {
//   const outcomes = [
//     {
//       iconClass: 'bi bi-bar-chart-line',
//       title: 'Learn to Use AI to Maximize Their Output in Less Time',
//       description:
//         'Attendees learn how to inject AI throughout the marketing workflow to accelerate tasks like audience segmentation, competitor analysis, campaign ideation, content creation, performance measurement, and more.',
//     },
//     {
//       iconClass: 'bi bi-gear-fill',
//       title: 'Deploy AI Assistants To Accomplish More Than Ever Before',
//       description:
//         'Attendees will leverage AI agents to handle valuable marketing tasks on their behalf, allowing them to focus on high-impact strategies, creative ideation, and other rewarding initiatives that drive tangible results.',
//     },
//     {
//       iconClass: 'bi bi-list-ul',
//       title: 'Receive Live, In-Person Training Led by AI Experts',
//       description:
//         'Attendees learn side-by-side with expert instructors who guide them through implementing the most advanced applications of AI to the marketing workflow.',
//     },
//   ];

//   return (
//     <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
//       <Container>
//         <h3 className="mb-4">Attendees Will:</h3>
//         <Row>
//           {outcomes.map((o, idx) => (
//             <OutcomeItem key={idx} {...o} />
//           ))}
//         </Row>
//       </Container>
//     </section>
//   );
// };



const LearningOutcomes = ({outcomes}) => {

  return (
    <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
      <Container>
        <h3 className="mb-4">Attendees Will:</h3>
        <Row>
          {outcomes.map((o, idx) => (
            <OutcomeItem key={idx} {...o} />
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default LearningOutcomes;
